import React from "react";

import { get } from "lodash";
import cx from "classnames";

import Icons from "../../icons";
import { ICONS } from "../../../constants/icons.constants";
import { songActions } from "../../../actions";
import ignoredSongStore from "../../../zustand/ignoreSong.store";

import styles from "./ignore.module.scss";
import userStore from "../../../zustand/user.store";
import favoriteSongStore from "../../../zustand/favoriteSong.store";

const Ignore = ({ row }) => {
  const { songs: ignoredSongs, setIgnoreToSong } = ignoredSongStore();
  const { removeFavouriteFromSong } = favoriteSongStore();

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const id = get(row, "id", "");

  const handleIgnore = async (e) => {
    e.stopPropagation();

    setIgnoreToSong(id);
    removeFavouriteFromSong(id);

    const isSuccess = await songActions.addReactionToSong(
      id,
      "IGNORE",
      userOffline
    );

    if (!isSuccess) {
      setIgnoreToSong(id);
      removeFavouriteFromSong(id);
    }
  };

  return (
    <div
      onClick={handleIgnore}
      className={cx(styles.column3, {
        [styles.ignore]: get(ignoredSongs, id, false),
      })}
    >
      <Icons type={ICONS.IGNORE_SONG} />
    </div>
  );
};

export default Ignore;
